import styled from "styled-components";
import React from "react";

const SectionHeadingWrapper = styled.div<{ contentWidth?: string; align?: "left" | "right"; $weight?: number }>`
  ${({ contentWidth }) => contentWidth
    ? `width: 100%; max-width: ${contentWidth}; margin: 0 auto;`
    : 'width: 100%;'}
  display: flex;
  align-items: flex-end;
  justify-content: ${({ align }) => (align === "right" ? "flex-end" : "flex-start")};
  font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
  font-weight: ${({ $weight }) => $weight ?? 600};
  column-gap: 0.2em;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

const SectionInner = styled.div<{ expand?: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${({ expand }) => (expand ? "100%" : "fit-content")};
  margin: ${({ expand }) => (expand ? "0 auto" : "0")};
`;

type SectionProps = {
  children: React.ReactNode;
  title?: string;
  color?: string;
  headless?: boolean;
  expand?: boolean;
  contentWidth?: string;
  id?: string;
};

const SectionWrapper = styled.section<{ headless?: boolean }>`
  margin-top: ${({ headless }) => (headless ? "2rem" : "3rem")};
  display: flex;
  justify-content: center;
`;

export function SectionHeading({
  children,
  color,
  contentWidth,
  align,
  weight,
  markerSize = "0.8em",
  markerOffset = "0.3em",
}: {
  children: React.ReactNode;
  color?: string;
  contentWidth?: string;
  align?: "left" | "right";
  weight?: number;
  markerSize?: string;
  markerOffset?: string;
}) {
  return (
    <SectionHeadingWrapper contentWidth={contentWidth} align={align} $weight={weight}>
      <div
        style={{
          width: markerSize,
          height: markerSize,
          backgroundColor: color,
          position: "relative",
          bottom: markerOffset,
          marginRight: "0.25em",
        }}
      />
      {children}
    </SectionHeadingWrapper>
  );
}

const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ children, title, color, expand, headless, contentWidth, id }, ref) => {
    return (
      <SectionWrapper ref={ref} id={id} headless={headless}>
        <SectionInner expand={expand}>
          {!headless && (
            <SectionHeading color={color} contentWidth={contentWidth}>
              {title}
            </SectionHeading>
          )}

          {children}
        </SectionInner>
      </SectionWrapper>
    );
  }
);

Section.displayName = "Section";

export { Section };
